<div class="center">
    <mat-card>
        <img mat-card-image class="header-image" src="assets/tichu_logo.png">
        <mat-card-header>
            <mat-card-title>
                Login to Tichu Tracker
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="signInForm" autocomplete="off">
                <mat-form-field appearance="outline" color="accent">
                    <mat-label>Enter your email</mat-label>
                    <input matInput placeholder="john.doe@example.com" formControlName="email" required>
                    <mat-icon matPrefix>email</mat-icon>
                </mat-form-field>
                <mat-form-field appearance="outline" color="accent">
                    <mat-label>Enter your password</mat-label>
                    <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password" required>
                    <mat-icon matPrefix>https</mat-icon>
                    <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword">
                        <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                    </button>
                </mat-form-field>
            </form>
            <p class="errorMessage" *ngIf="errorMessage.length > 0">
                {{errorMessage}}
            </p>
            <div class="button-container">
                <button mat-raised-button color="primary" (click)="login()">Login</button>
                <button mat-raised-button color="accent" (click)="goToRegistration()">Register</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
